/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { SearchBox } from '@fluentui/react/lib/SearchBox';
import { withDebouncedInput } from 'src/core/utils/hocs/withDebouncedInput';

/**
 * Represents a search box with local query state that does not
 * sync with the parent container until after a specified debounce
 * time value.
 */
export const LuisDebouncedSearchBox = withDebouncedInput(SearchBox);
